
<p-select [(ngModel)]="selectedAirport" [options]="dropdownItems"  (ngModelChange)="onAirportSelected($event)" [disabled]="disabled" (onBlur)="touched()">
  <ng-template pTemplate="selectedItem" let-airport>
    {{airport.aircode}}
  </ng-template>
  <ng-template let-airport pTemplate="item">
    {{airport.aircode}} 
    @if(airport.name){
     - {{airport.name}}
    }
  </ng-template>
</p-select>
